
import * as React from "react"
import * as AspectRatioPrimitive from "@radix-ui/react-aspect-ratio"
import { cn } from "@/lib/utils"

const AspectRatio = React.forwardRef<
  React.ElementRef<typeof AspectRatioPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof AspectRatioPrimitive.Root> & {
    containerClassName?: string;
  }
>(({ className, containerClassName, ...props }, ref) => (
  <div className={cn("overflow-hidden rounded-md", containerClassName)}>
    <AspectRatioPrimitive.Root
      ref={ref}
      className={cn("relative w-full", className)}
      {...props}
    />
  </div>
))
AspectRatio.displayName = "AspectRatio"

export { AspectRatio }
